<section class="check-ins" aria-labelledby="check-ins-title">
  <h2 id="check-ins-title" class="check-ins__title">Check-ins</h2>

  @if (isLoading()) {
    <p class="check-ins__message" aria-live="polite">Loading check-ins…</p>
  } @else if (errorMessage()) {
    <p class="check-ins__message" role="status">
      {{ errorMessage() }}
    </p>
  } @else {
    @let items = checkIns();

    @if (items.length > 0) {
      <div class="check-ins__list">
        @for (item of items; track item.id) {
          <article class="check-ins__item">
            <header class="check-ins__item-header">
              @if (allowOwnerNavigation() && item.petszelOwnerId) {
                <button
                  type="button"
                  class="check-ins__owner-link"
                  [attr.aria-label]="
                    'View ' + item.ownerName + ' pet parent profile'
                  "
                  (click)="onViewOwner(item.petszelOwnerId)"
                >
                  {{ item.ownerName }}
                </button>
              } @else {
                <h3 class="check-ins__owner-name">
                  {{ item.ownerName }}
                </h3>
              }

              <span
                class="
                  check-ins__status
                  {{ item.statusClass }}
                "
              >
                {{ item.status }}
              </span>
            </header>

            @if (isAdopterUnknown(item)) {
              <div class="petszel-warning-alert">
                <div class="petszel-warning-alert__icon">
                  <lib-icon iconName="utilityWarningIcon"></lib-icon>
                </div>
                <div class="petszel-warning-alert__content">
                  This adopter did not opt in to post-adoption support at checkout. Please refer to the knowledge base article <a
                  href="https://support.petszel.com/en-us/sheltersupport/how-do-i-update?hs_preview=PcbZXWLs-188752473110" target="_blank">here</a> to update this record.
                </div>
              </div>
            }

            <dl class="check-ins__events">
              <div class="check-ins__event">
                <dt class="check-ins__event-heading">
                  <span class="check-ins__event-label"> Start </span>

                  @if (item.start.date) {
                    <time class="check-ins__event-date">
                      {{ item.start.date }}
                    </time>
                  }
                </dt>

                <dd class="check-ins__event-content">
                  @if (item.start.description) {
                    {{ item.start.description }}
                  }
                </dd>
              </div>

              @if (item.end; as endEvent) {
                <div class="check-ins__event">
                  <dt class="check-ins__event-heading">
                    <span class="check-ins__event-label"> End </span>

                    @if (endEvent.date) {
                      <time class="check-ins__event-date">
                        {{ endEvent.date }}
                      </time>
                    }
                  </dt>

                  <dd class="check-ins__event-content">
                    @if (endEvent.description) {
                      {{ endEvent.description }}
                    }
                  </dd>
                </div>
              }
            </dl>
          </article>
        }
      </div>
    } @else {
      <p class="check-ins__message">No check-ins available.</p>
    }
  }
</section>
